'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestApplicationTypes', ['$http', '$q', function ($http, $q) {
        var save = function (lrat) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/LicenseRequestApplicationTypes/';
            if (!isUndefined(lrat.id)) {
                method = 'PUT'
                url += lrat.id
            }

            $http({
                method: method,
                url: url,
                data: {
                    license_request_application_type: lrat
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var clearElement = function (licenseRequestID) {
            var d = $q.defer();

            $http
                .post(apiLocation + '/api/LicenseRequestApplicationTypes/clearElement', {
                    license_request_id: licenseRequestID
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequestApplicationTypes', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: save,

            saveElement: function (answer, licenseRequestID) {
                var d = $q.defer();
                var promises = [];

                clearElement(licenseRequestID).then(function () {
                    for (var key in answer) {
                        // skip loop if the property is from prototype
                        if (!answer.hasOwnProperty(key)) continue;

                        var ids = key.split('%');
                        if (ids.length == 2) {
                            var typeID = ids[0];
                            var levelID = ids[1];
                            if (isValidGuid(typeID) && isValidGuid(levelID)) {
                                promises.push(save({
                                    license_request_id: licenseRequestID,
                                    application_type_id: typeID,
                                    license_request_level_id: levelID,
                                    checked: answer[key]
                                }))
                            }
                        }
                    }

                    $q.all(promises).then(function () {
                        d.resolve();
                    }).catch(function (response) {
                        // handle error
                    });
                })                

                return d.promise;
            }
        }
    }])
;